import React, {useState} from "react";
import {Button} from "@mui/material";
import Modal from "../../../../../modals/admin";


export default function Department(props){

    const {sizeType} = props

    const [modalOpen, setModalOpen] = useState(false);

    const openModal=()=>{
        setModalOpen(true);
    };
    const closeModal=()=>{
        setModalOpen(false);
    }


    return(
        <>
            <Button
                variant="contained"
                size="large"
                onClick={openModal}
                sx={{marginRight:2}}
            >
                부서 별 수정
            </Button>
            {modalOpen && <>
                {sizeType === 'mobile' ? (
                    <>
                        <Modal open={modalOpen} close={closeModal} header="부서 별 수정"
                               sizeType="mobile"  />
                    </>
                ):(
                    <>
                        <Modal open={modalOpen} close={closeModal} header="부서 별 수정"  />
                    </>
                )}
            </>}
        </>
    )
}